import { Component, Input, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WritingFeedbackRequestModalComponent } from '../writing-feedback-request-modal/writing-feedback-request-modal.component';
import { TranslatePipe } from '../translate.pipe';

@Component({
  selector: 'lp2-writing-feedback-request-button',
  templateUrl: './writing-feedback-request-button.component.html',
  styleUrls: ['./writing-feedback-request-button.component.scss'],
})
export class WritingFeedbackRequestButtonComponent {
  @Input() message = '';

  constructor(private modalService: NgbModal, element: ElementRef, translatePipe: TranslatePipe) {
    // We have to do this here, since it is an input on a root component
    const nativeElementMessage = element.nativeElement.getAttribute('message-key');
    if (nativeElementMessage) {
      this.message = translatePipe.transform(nativeElementMessage);
    }
  }

  openWritingFeedbackRequestModal() {
    this.modalService.open(WritingFeedbackRequestModalComponent, { size: 'lg' });
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/writing-feedback-request-button/writing-feedback-request-button.component.ts